import { Tab, Tabs, Typography } from '@mui/material';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { statisticsTabsTranslation } from './translation';
import { StatisticsTab, useStatisticsTabs } from './useStatisticsTabs';
import { useStatisticsTabsStyles } from './useStatisticsTabsStyles';

export const StatisticsTabs = () => {
  const { classes } = useStatisticsTabsStyles();
  const { keys, t } = useTranslation(statisticsTabsTranslation);
  const { currentTab, handleChangeTab } = useStatisticsTabs();

  return (
    <div className={classes.root}>
      <Tabs
        indicatorColor="primary"
        onChange={handleChangeTab}
        value={currentTab}
        variant="standard"
      >
        <Tab
          className={classes.tab}
          label={
            <Typography variant="subtitle1">{t(keys.statistics)}</Typography>
          }
          value={StatisticsTab.Statistics}
        />
        <Tab
          className={classes.tab}
          label={<Typography variant="subtitle1">{t(keys.rawData)}</Typography>}
          value={StatisticsTab.Raw}
        />
      </Tabs>
    </div>
  );
};
